import React, {
} from 'react';
import { bool, func, string } from 'prop-types';

import { Button } from '@thd-olt-component-react/button';

import { noop } from '../../utils/promo-utils';
import { usePromoCart } from '../../contexts/PromoCartProvider';
import './PromoSelectCta.scss';

export const PromoSelectCta = ({
  onSelect, selected, className, dark
}) => {
  const { freeItemInCart, isCartLoading } = usePromoCart();

  const unselectedMessaging = freeItemInCart ? 'Select This Instead' : 'Select This Item';
  const selectedMessaging = 'Unselect Item';

  return (
    <div className={'promo-select-cta ' + className}>
      {(freeItemInCart && selected)
        ? (
          <div className="promo-select-cta--free u__bold">
            <span className="u__text--success">Free Item</span> is in Cart
          </div>
        )
        : (
          <Button
            onClick={onSelect}
            dark={dark}
            disabled={isCartLoading}
            outline
          >
            {selected ? selectedMessaging : unselectedMessaging}
          </Button>
        )}
    </div>
  );
};

PromoSelectCta.displayName = 'PromoSelectCta';

PromoSelectCta.propTypes = {
  dark: bool,
  selected: bool,
  onSelect: func,
  className: string
};

PromoSelectCta.defaultProps = {
  dark: false,
  selected: false,
  onSelect: noop,
  className: ''
};
